
import styles from './Shortcuts.module.scss'


export default function Shortcuts(
  {
    hasAbout,
    hasPractical,
    hasPhotos,
    hasCondolences,
    hasObituary,
    isExtended,
  }: {
    hasAbout: boolean,
    hasPractical: boolean,
    hasPhotos: boolean,
    hasCondolences: boolean,
    hasObituary: boolean,
    isExtended: boolean,
  }) {

  return <section className={[styles.shortcuts, isExtended && styles.extended].join(' ')}>
    <div className={[styles.wrapper, 'wrapper'].join(' ')}>
      <ul>
        {hasAbout && <li><a href={"#about"}>Over</a></li>}
        {hasCondolences && <li><a href={"#interactions"}>Condoleances</a></li>}
        {hasPractical && <li><a href={"#practical"}>Praktische informatie</a></li>}
        {hasPhotos && <li><a href={"#photos"}>Foto's</a></li>}
        {hasObituary && <li><a href={"#obituary"}>Overlijdensbericht</a></li>}
      </ul>
    </div>
  </section>
}
